import React from 'react';
import './onboarding-tool-tip-2023.css';
import { isAfter, addDays, format } from 'date-fns';
const OnboardingToolTip2023 = ({card, calendarEvents}) => {
    const [scheduledEvents, setScheduledEvents] = React.useState([])
    const [infoLessonInfo, setIntroLessonInfo] = React.useState(false)

    React.useEffect(() => {
        getFamilyInfo()
    }, [])

    React.useEffect(() => {
        scheduledEvents.map((event) => {
            card.studentList.map((dbStudent) => {
                if(event.studentId === dbStudent.studentId && !event.isPendingOffer && isAfter(new Date(event.dateTime), addDays(new Date(), -5))) {
                    setIntroLessonInfo(event)
                }
            })
        })
    }, [scheduledEvents])

    const getFamilyInfo = async () => {
        let familiesCalendarEvents = []
        calendarEvents.map((event) => {
            card.studentList.map((dbStudent) => {
                if(event.studentId === dbStudent.studentId) {
                    familiesCalendarEvents.push(event)
                }
            })
        })
        setScheduledEvents(familiesCalendarEvents)
    }

    return (
        <div className='onboarding-tool-tip-2023__wrapper'>
            <div className='onboarding-tool-tip-2023__family-name'>{card.todoName}</div>
            {card.studentList.map((student, index) => 
            <div key={index} className='onboarding-tool-tip-2023__each-student__wrapper'>
                <div className='onboarding-tool-tip-2023__each-student-name'>{student.studentName.split(' ')[0]}</div>
                <div className='onboarding-tool-tip-2023__each-student-inst__wrapper'>{student.instrumentList.map((instrument, index) => <div key={index} className='onboarding-tool-tip-2023__each-student-inst'>{instrument.name}</div>)}</div>
                {infoLessonInfo && 
                    <div className='onboarding-tool-tip-2023__each-student-lesson-date'>
                        <div className='onboarding-tool-tip-2023__each-student-date'>{format(new Date(infoLessonInfo.dateTime), 'MM/d')}</div>
                        <div className='onboarding-tool-tip-2023__each-student-teacher'>{infoLessonInfo.teacherName}</div>
                    </div>}
            </div>
            )}
        </div>
    )
}
export default OnboardingToolTip2023;